import lmRequest from '../shared/lmRequest';

const init = phoneNumber => {
  return lmRequest({
    url: 'api/loginManager/otp/init',
    method: 'POST',
    data: {
      '@type': 'OtpInitRequestByPhoneNumber',
      phoneNumber,
    },
  });
};

const logout = () => {
  return lmRequest({
    url: 'api/loginManager/logout',
    method: 'POST',
  });
};

const LoginManagerServices = {
  logout,
  init,
};

export default LoginManagerServices;
